(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collector-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select.matches('.direct-buy-product__form select[name="id"]')) return;
    var option = select.options[select.selectedIndex];
    var price = select.closest('.direct-buy-product__purchase').querySelector('[data-variant-price]');
    if (price && option) price.textContent = option.dataset.price;
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.classList.contains('direct-buy-product__form')) return;
    var button = form.querySelector('[data-add-to-cart]');
    if (!button || button.disabled) return;
    button.classList.add('is-loading');
    button.querySelector('.direct-buy-product__add-to-cart-label').textContent = button.dataset.loadingLabel;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["direct-buy-home"] && !Shopify.designMode) return;
  try {
    

  document.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
    const toggle = carousel.querySelector('[data-carousel-toggle]');
    if (slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let activeIndex = 0;
    let interval;
    let userPaused = false;
    const showSlide = (index) => {
      slides[activeIndex].classList.remove('is-active');
      slides[activeIndex].setAttribute('aria-hidden', 'true');
      activeIndex = index;
      slides[activeIndex].classList.add('is-active');
      slides[activeIndex].setAttribute('aria-hidden', 'false');
    };
    const stop = () => window.clearInterval(interval);
    const start = () => {
      if (userPaused) return;
      stop();
      interval = window.setInterval(() => showSlide((activeIndex + 1) % slides.length), 4500);
    };
    if (toggle) {
      toggle.addEventListener('click', () => {
        userPaused = !userPaused;
        toggle.setAttribute('aria-pressed', String(userPaused));
        toggle.textContent = userPaused ? 'Play' : 'Pause';
        if (userPaused) stop(); else start();
      });
    }
    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', start);
    start();
  });

  document.querySelectorAll('[data-campaign-countdown]').forEach((campaign) => {
    const timer = campaign.querySelector('.direct-buy-home__timer');
    const endAt = new Date(campaign.dataset.end).getTime();

    if (!timer || Number.isNaN(endAt)) return;

    const updateTimer = () => {
      const remaining = endAt - Date.now();

      if (remaining <= 0) {
        timer.textContent = 'This offer has ended.';
        return true;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      timer.textContent = `Ends in ${days}d ${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`;
      return false;
    };

    if (!updateTimer()) {
      const interval = window.setInterval(() => {
        if (updateTimer()) window.clearInterval(interval);
      }, 1000);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const popup = document.querySelector('[data-private-list-popup]');
    if (!popup) return;
    const key = 'private-list-hidden-until';
    const week = 7 * 24 * 60 * 60 * 1000;
    const setHidden = () => localStorage.setItem(key, String(Date.now() + week));
    const isHidden = () => Number(localStorage.getItem(key) || 0) > Date.now();
    const show = () => { if (!isHidden()) popup.hidden = false; };
    const success = popup.querySelector('.private-list__success');
    if (popup.dataset.privateListSubscribed === 'true') { setHidden(); return; }
    if (success) { popup.hidden = false; setHidden(); return; }
    window.setTimeout(show, 30000);
    document.addEventListener('mouseout', (event) => { if (event.clientY <= 0) show(); });
    popup.querySelector('[data-private-list-close]')?.addEventListener('click', () => { setHidden(); popup.hidden = true; });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
